import DocumentItemService from '@/service/document-item'

export default {
  getListDocumentItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentItemService.getListDocumentItem(payload.document).then(res => {
        commit('getListDocumentItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  showDocumentItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentItemService.showDocumentItem(payload.document_item).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  createDocumentItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentItemService.createDocumentItem(payload.document_item).then(res => {
        commit('createDocumentItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  updateDocumentItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentItemService.updateDocumentItem(payload.document_item).then(res => {
        commit('updateDocumentItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  destroyDocumentItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentItemService.destroyDocumentItem(payload.document_item).then(res => {
        commit('destroyDocumentItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  importDocumentItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentItemService.importDocumentItem(payload.document, payload.file).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  uploadImageDocumentItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentItemService.uploadImageDocumentItem(payload.data).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  updateNodeDocumentItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentItemService.updateNodeDocumentItem(payload).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  setDocumentQueue ({commit}, payload) {
    commit('setDocumentQueue', payload)
  },

  removeDocumentQueue ({commit}, payload) {
    commit('removeDocumentQueue', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/document-item/actions.js